import { ChakraAvatar } from '@equip.health/ui';

interface ChatAvatarProps {
  id?: string;
  name: string;
  size?: 'md' | 'sm';
}

const ChatAvatar = ({ name, id, size = 'md' }: ChatAvatarProps) => {
  const rectSize = size === 'md' ? '40px' : '24px';
  const avatarSize = size === 'md' ? 'sm' : 'xs';

  return (
    <ChakraAvatar
      backgroundColor="primary.50"
      color="white"
      height={rectSize}
      id={id}
      name={name}
      size={avatarSize}
      width={rectSize}
    />
  );
};

ChatAvatar.displayName = 'ChatAvatar';
export default ChatAvatar;
